import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function fetchProjectBudgetTrackingQuery(projectId) {
  const { project } =  await fetchData(`api/projects/show/${projectId}`, APIMethod.GET, {
    baseURL: ACCESS_DOMAINS.btApi,
  });
  return project;
}